<template>
    <div class="preference" v-loading="loading">
        <el-form ref="formData" :model="formData" :rules="formRules" class="custom-form" label-width="160px">
            <!-- 任务名称 -->
            <el-form-item :label="$t('message.table.taskName')" prop="task" class="full-width-item">
                <el-input v-model="formData.task" :placeholder="$t('message.placeholder.PleaseEnterTheTaskName')"
                    clearable maxlength="40" show-word-limit />
            </el-form-item>

            <!-- 任务描述 -->
            <el-form-item :label="$t('message.table.taskDescription')" prop="taskDescription" class="full-width-item">
                <el-input v-model="formData.taskDescription"
                    :placeholder="$t('message.placeholder.PleaseEnterTaskDescription')" clearable maxlength="200"
                    show-word-limit />
            </el-form-item>

            <!-- 执行周期选择 -->
            <el-form-item :label="$t('message.table.executeCycle')" prop="executeCycle" class="full-width-item">
                <el-select v-model="formData.executeCycle"
                    :placeholder="$t('message.placeholder.PleaseSelectExecutionCycle')" clearable
                    @change="handleCycleChange">
                    <el-option v-for="item in triggerOptions" :key="item.value" :label="item.label"
                        :value="item.value" />
                </el-select>
            </el-form-item>

            <!-- 执行星期 -->
            <el-form-item v-if="showExecutionWeek" :label="$t('message.table.executionWeek')" prop="executionWeek"
                class="full-width-item">
                <el-select v-model="formData.executionWeek"
                    :placeholder="$t('message.placeholder.PleaseSelectExecutionWeek')" clearable>
                    <el-option v-for="item in weekOptions" :key="item.value" :label="item.label" :value="item.value" />
                </el-select>
            </el-form-item>

            <!-- 执行时间选择 -->
            <el-form-item :label="$t('message.table.executeTime')" prop="executeTime" class="full-width-item">
                <el-select v-model="formData.executeTime" :placeholder="$t('message.placeholder.PleaseSelectTime')"
                    clearable>
                    <el-option v-for="item in timesOptions" :key="item.value" :label="item.label" :value="item.value" />
                </el-select>

            </el-form-item>

            <!-- 通知方式选择 -->
            <el-form-item :label="$t('message.table.notificationMethod')" prop="notificationMethod"
                class="full-width-item">
                <el-select v-model="formData.notificationMethod"
                    :placeholder="$t('message.placeholder.PleaseChooseNotificationMethod')" clearable>
                    <el-option v-for="item in notificationMethodOptions" :key="item.value" :label="item.label"
                        :value="item.value" />
                </el-select>
            </el-form-item>

            <!-- 是否启用选择 -->
            <el-form-item :label="$t('message.table.isEnabled')" prop="isEnabled" class="full-width-item">
                <el-select v-model="formData.isEnabled"
                    :placeholder="$t('message.placeholder.PleaseChooseEnableOption')" clearable>
                    <el-option v-for="item in isEnabledOptions" :key="item.value" :label="item.label"
                        :value="item.value" />
                </el-select>
            </el-form-item>

            <!-- 收件人选择 -->
            <el-form-item :label="$t('message.table.recipient')" prop="recipient" class="full-width-item">
                <el-input v-model="formData.recipient"
                    :placeholder="$t('message.placeholder.PleaseEnterTheRecipientEmailAddress')" clearable
                    show-word-limit />
            </el-form-item>

            <!-- 抄送人输入 -->
            <el-form-item :label="$t('message.table.cc')" prop="cc" class="full-width-item">
                <el-input v-model="formData.cc"
                    :placeholder="$t('message.placeholder.PleaseEnterTheCCRecipientEmailAddress')" clearable
                    show-word-limit />
            </el-form-item>

            <!-- 操作按钮 -->
            <el-form-item class="form-actions">
                <el-button class="btn btn1" icon="el-icon-document-checked" @click="submitForm">
                    {{ $t('message.button.save') }}</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
export default {
    data() {
        return {
            formData: {
                task: '',
                taskDescription: '',
                executeCycle: '',
                executionWeek: '',
                executeTime: '',
                notificationMethod: '',
                isEnabled: '',
                recipient: '',
                cc: ''
            },
            loading: false,
            triggerOptions: [
                { value: '1', label: '单次' },
                { value: '2', label: '每日' },
                { value: '3', label: '每周' },
                { value: '4', label: '每月' }
            ],
            timesOptions: [
                { value: '20', label: '20' },
                { value: '21', label: '21' },
                { value: '22', label: '22' },
                { value: '24', label: '24' },
                { value: '1', label: '1' },
                { value: '2', label: '2' },
                { value: '3', label: '3' },
                { value: '4', label: '4' },
                { value: '5', label: '5' },
                { value: '6', label: '6' },
                { value: '7', label: '7' },
                { value: '8', label: '8' }
            ],
            weekOptions: [
                { value: '1', label: '星期一' },
                { value: '2', label: '星期二' },
                { value: '3', label: '星期三' },
                { value: '4', label: '星期四' },
                { value: '5', label: '星期五' },
                { value: '6', label: '星期六' },
                { value: '7', label: '星期日' }
            ],
            notificationMethodOptions: [
                { value: '1', label: '邮件' }
            ],
            isEnabledOptions: [
                { value: '1', label: '是' },
                { value: '0', label: '否' }
            ],
            formRules: {
                task: [
                    { required: true, message: '请输入任务名称', trigger: 'blur' },
                    { min: 1, max: 40, message: '长度在1到40个字符', trigger: 'blur' }
                ],
                executeCycle: [
                    { required: true, message: '请选择执行周期', trigger: 'change' }
                ],
                executionWeek: [
                    {
                        validator: (rule, value, callback) => {
                            if (this.formData.executeCycle === '3' && !value) {
                                callback(new Error('每周周期必须选择执行星期'))
                            } else {
                                callback()
                            }
                        },
                        trigger: 'change'
                    }
                ],
                executeTime: [
                    { required: true, message: '请选择执行时间', trigger: 'change' }
                ],
                notificationMethod: [
                    { required: true, message: '请选择执通知方式', trigger: 'change' }
                ],
                isEnabled: [
                    { required: true, message: '请选择是否启用', trigger: 'change' }
                ],
                recipient: [
                    { required: true, message: '请输入收件人邮箱', trigger: 'change' }
                ],
                cc: [
                    { required: true, message: '请输入抄送人邮箱', trigger: 'change' }
                ]
            }
        }
    },
    props: {
        privData: {
            type: Object,
            required: true,
            default: () => ({})
        }
    },
    watch: {
        privData: {
            immediate: true,
            handler(newVal) {
                if (Object.keys(newVal).length > 0) {
                    this.formData = { ...newVal };
                }
            }
        }
    },
    computed: {
        showExecutionWeek() {
            return this.formData.executeCycle === '每周' || this.formData.executeCycle === '3'
        },
    },
    created() { },
    methods: {
        handleCycleChange(value) {
            if (value !== '3') {
                this.formData.executionWeek = ''
            }
        },
        async submitForm() {
            try {
                const isValid = await this.$refs.formData.validate();
                if (isValid) {
                    console.log('✅ 表单验证通过，提交数据:', this.formData);
                    this.$emit('submit', this.formData);
                } else {
                    console.warn('⚠️ 表单验证失败，请检查输入');
                }
            } catch (error) {
                console.error('🚨 表单验证异常:', error);
            }
        }
    }
}
</script>

<style scoped>
.preference {
    width: 100%;
    height: 100%;
    background: #fff;
    overflow: hidden;
    overflow-y: auto;
}

.title-heading p {
    font-size: 18px;
    font-weight: 400;
    margin: 0;
}

s .custom-dialog ::v-deep .el-dialog__header {
    padding: 16px 20px;
    border-bottom: 1px solid #ebeef5;
    background: #f0faff;
}

.dialog-title-icon {
    color: #409eff;
    margin-right: 8px;
    font-size: 16px;
}

.dialog-title-text {
    font-size: 16px;
    color: #303133;
    font-weight: 500;
}

.full-width-item ::v-deep .el-form-item__content {
    flex: 1;
}

.full-width-item .el-input,
.full-width-item .el-select {
    width: 100%;
}

.data-marker-container {
    margin-top: 8px;
    display: flex;
    gap: 8px;
    width: 100%;
}

.data-field-select {
    flex: 1;
    min-width: 0;
}

.dialog-footer {
    display: flex;
    gap: 8px;
    justify-content: flex-end;
}



.notification-management {
    padding: 20px;
    background: #fff;
    border-radius: 4px;
}

.header {
    display: flex;
    align-items: center;
    gap: 16px;
    margin-bottom: 20px;
}

.filter-select {
    width: 120px;
}

.search-container {
    flex: 1;
    position: relative;
}

.search-input {
    width: 100%;
}

.search-icon {
    color: #909399;
    margin-left: 8px;
}

.lightning-icon {
    color: #f5a623;
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
}

.action-buttons {
    display: flex;
    gap: 8px;
}

.row-name {
    display: flex;
    align-items: center;
}

.el-switch {
    margin-top: 4px;
}

.form-actions {
    text-align: right;
}
</style>